import { Trans } from "@lingui/macro";
import { UiBox, UiIconStatus, UiTypography } from "@smp/ui";

export const Stub = () => (
  <UiBox
    alignItems="center"
    display="flex"
    flexDirection="column"
    justifyContent="center"
  >
    <UiBox mb={2}>
      <UiIconStatus variant="success" />
    </UiBox>
    <UiBox>
      <UiTypography align="center">
        <Trans>
          The purchase was made in full with own funds. No extra payments
          required.
        </Trans>
      </UiTypography>
      <UiTypography align="center">
        <Trans>Payment status will be updated in few minutes.</Trans>
      </UiTypography>
    </UiBox>
  </UiBox>
);
